export const CREATE_PROJECT_INIT = "CREATE_PROJECT_INIT";
export const CREATE_PROJECT_SUCCESS = "CREATE_PROJECT_SUCCESS";
export const CREATE_PROJECT_FAILED = "CREATE_PROJECT_FAILED";
export const GET_PROJECT_ANALYTICS_INIT = "GET_PROJECT_ANALYTICS_INIT";
export const GET_PROJECT_ANALYTICS_SUCCESS = "GET_PROJECT_ANALYTICS_SUCCESS";
export const GET_PROJECT_ANALYTICS_FAILED = "GET_PROJECT_ANALYTICS_FAILED";
export const GET_NO_PROJECTS_BY_TYPE_INIT = "GET_NO_PROJECTS_BY_TYPE_INIT";
export const GET_NO_PROJECTS_BY_TYPE_SUCCESS =
  "GET_NO_PROJECTS_BY_TYPE_SUCCESS";
export const GET_NO_PROJECTS_BY_TYPE_FAILED = "GET_NO_PROJECTS_BY_TYPE_FAILED";
export const GET_OVERALL_PROGRESS_INIT = "GET_OVERALL_PROGRESS_INIT";
export const GET_OVERALL_PROGRESS_SUCCESS = "GET_OVERALL_PROGRESS_SUCCESS";
export const GET_OVERALL_PROGRESS_FAILED = "GET_OVERALL_PROGRESS_FAILED";
export const GET_PROJECT_DETAILS_BY_ID_INIT = "GET_PROJECT_DETAILS_BY_ID_INIT";
export const GET_PROJECT_DETAILS_BY_ID_SUCCESS =
  "GET_PROJECT_DETAILS_BY_ID_SUCCESS";
export const GET_PROJECT_DETAILS_BY_ID_FAILED =
  "GET_PROJECT_DETAILS_BY_ID_FAILED";
export const UPDATE_PROJECT_DETAILS_BY_ID_INIT =
  "UPDATE_PROJECT_DETAILS_BY_ID_INIT";
export const UPDATE_PROJECT_DETAILS_BY_ID_SUCCESS =
  "UPDATE_PROJECT_DETAILS_BY_ID_SUCCESS";
export const UPDATE_PROJECT_DETAILS_BY_ID_FAILED =
  "UPDATE_PROJECT_DETAILS_BY_ID_FAILED";
export const GET_PROJECT_KANBAN_VIEW_INIT = "GET_PROJECT_KANBAN_VIEW_INIT";
export const GET_PROJECT_KANBAN_VIEW_SUCCESS =
  "GET_PROJECT_KANBAN_VIEW_SUCCESS";
export const GET_PROJECT_KANBAN_VIEW_FAILED = "GET_PROJECT_KANBAN_VIEW_FAILED";
export const GET_PROJECT_KANBAN_RESOURCE_INIT =
  "GET_PROJECT_Kanban_RESOURCE_INIT";
export const GET_PROJECT_KANBAN_RESOURCE_SUCCESS =
  "GET_PROJECT_KANBAN_RESOURCE_SUCCESS";
export const GET_PROJECT_KANBAN_RESOURCE_FAILED =
  "GET_PROJECT_KANBAN_RESOURCE_FAILED";
export const ADD_RESOURCE_INIT = "ADD_RESOURCE_INIT";
export const ADD_RESOURCE_SUCCESS = "ADD_RESOURCE_SUCCESS";
export const ADD_RESOURCE_FAILED = "ADD_RESOURCE_FAILED";
export const REMOVE_RESOURCE_INIT = "REMOVE_RESOURCE_INIT";
export const REMOVE_RESOURCE_SUCCESS = "REMOVE_RESOURCE_SUCCESS";
export const REMOVE_RESOURCE_FAILED = "REMOVE_RESOURCE_FAILED";
export const GET_ADD_RESOURCE_INIT = "GET_ADD_RESOURCE_INIT";
export const GET_ADD_RESOURCE_SUCCESS = "GET_ADD_RESOURCE_SUCCESS";
export const GET_ADD_RESOURCE_FAILED = "GET_ADD_RESOURCE_FAILED";
export const GET_PROJECTS_LIST_INIT = "GET_PROJECTS_LIST_INIT";
export const GET_PROJECTS_LIST_SUCCESS = "GET_PROJECTS_LIST_SUCCESS";
export const GET_PROJECTS_LIST_FAILED = "GET_PROJECTS_LIST_FAILED";
export const GET_RESOURCE_BY_ID_INIT = "GET_RESOURCE_BY_ID_INIT";
export const GET_RESOURCE_BY_ID_SUCCESS = "GET_RESOURCE_BY_ID_SUCCESS";
export const GET_RESOURCE_BY_ID_FAILED = "GET_RESOURCE_BY_ID_FAILED";
export const GET_PL_STATEMENT_BUDGET_INIT = "GET_PL_STATEMENT_BUDGET_INIT";
export const GET_PL_STATEMENT_BUDGET_SUCCESS =
  "GET_PL_STATEMENT_BUDGET_SUCCESS";
export const GET_PL_STATEMENT_BUDGET_FAILED = "GET_PL_STATEMENT_BUDGET_FAILED";
export const GET_PL_STATEMENT_FORECAST_INIT = "GET_PL_STATEMENT_FORECAST_INIT";
export const GET_PL_STATEMENT_FORECAST_SUCCESS =
  "GET_PL_STATEMENT_FORECAST_SUCCESS";
export const GET_PL_STATEMENT_FORECAST_FAILED =
  "GET_PL_STATEMENT_FORECAST_FAILED";
export const GET_BUDGET_FORECAST_INIT = "GET_BUDGET_FORECAST_INIT";
export const GET_BUDGET_FORECAST_SUCCESS = "GET_BUDGET_FORECAST_SUCCESS";
export const GET_BUDGET_FORECAST_FAILED = "GET_BUDGET_FORECAST_FAILED";
export const GET_BREAKDOWN_CHART_INIT = " GET_BREAKDOWN_CHART_INIT";
export const GET_BREAKDOWN_CHART_SUCCESS = "GET_BREAKDOWN_CHART_SUCCESS";
export const GET_BREAKDOWN_CHART_FAILED = "GET_BREAKDOWN_CHART_FAILED";
export const GET_TOTAL_COST_INIT = " GET_TOTAL_COST_INIT";
export const GET_TOTAL_COST_SUCCESS = "GET_TOTAL_COST_SUCCESS";
export const GET_TOTAL_COST_FAILED = "GET_TOTAL_COST_FAILED";
export const GET_TOTAL_BUDGET_INIT = " GET_TOTAL_BUDGET_INIT";
export const GET_TOTAL_BUDGET_SUCCESS = "GET_TOTAL_BUDGET_SUCCESS";
export const GET_TOTAL_BUDGET_FAILED = "GET_TOTAL_BUDGET_FAILED";
export const ADD_RESOURCE_REQUESTS_INIT = "ADD_RESOURCE_REQUESTS_INIT";
export const ADD_RESOURCE_REQUESTS_SUCCESS = "ADD_RESOURCE_REQUESTS_SUCCESS";
export const ADD_RESOURCE_REQUESTS_FAILED = "ADD_RESOURCE_REQUESTS_FAILED";
export const DOWNLOAD_PROJECT_ANALYTICS_INIT =
  "DOWNLOAD_PROJECT_ANALYTICS_INIT";
export const DOWNLOAD_PROJECT_ANALYTICS_SUCCESS =
  "DOWNLOAD_PROJECT_ANALYTICS_SUCCESS";
export const DOWNLOAD_PROJECT_ANALYTICS_FAILED =
  "DOWNLOAD_PROJECT_ANALYTICS_FAILED";
export const GET_NAMED_RESOURCES_ALLOCATIONS_INIT =
  "GET_NAMED_RESOURCES_ALLOCATIONS_INIT";
export const GET_NAMED_RESOURCES_ALLOCATIONS_SUCCESS =
  "GET_NAMED_RESOURCES_ALLOCATIONS_SUCCESS";
export const GET_NAMED_RESOURCES_ALLOCATIONS_FAILED =
  "GET_NAMED_RESOURCES_ALLOCATIONS_FAILED";
export const GET_UNNAMED_RESOURCES_ALLOCATIONS_INIT =
  "GET_UNNAMED_RESOURCES_ALLOCATIONS_INIT";
export const GET_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS =
  "GET_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS";
export const GET_UNNAMED_RESOURCES_ALLOCATIONS_FAILED =
  "GET_UNNAMED_RESOURCES_ALLOCATIONS_FAILED";
export const UPDATE_NAMED_RESOURCES_ALLOCATIONS_INIT =
  "UPDATE_NAMED_RESOURCES_ALLOCATIONS_INIT";
export const UPDATE_NAMED_RESOURCES_ALLOCATIONS_SUCCESS =
  "UPDATE_NAMED_RESOURCES_ALLOCATIONS_SUCCESS";
export const UPDATE_NAMED_RESOURCES_ALLOCATIONS_FAILED =
  "UPDATE_NAMED_RESOURCES_ALLOCATIONS_FAILED";
export const UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_INIT =
  "UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_INIT";
export const UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS =
  "UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_SUCCESS";
export const UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_FAILED =
  "UPDATE_UNNAMED_RESOURCES_ALLOCATIONS_FAILED";
export const ADD_TO_PROJECT_NAMED_INIT = "ADD_TO_PROJECT_NAMED_INIT";
export const ADD_TO_PROJECT_NAMED_SUCCESS = "ADD_TO_PROJECT_NAMED_SUCCESS";
export const ADD_TO_PROJECT_NAMED_FAILED = "ADD_TO_PROJECT_NAMED_FAILED";
export const ADD_TO_PROJECT_UNNAMED_INIT = "ADD_TO_PROJECT_UNNAMED_INIT";
export const ADD_TO_PROJECT_UNNAMED_SUCCESS = "ADD_TO_PROJECT_UNNAMED_SUCCESS";
export const ADD_TO_PROJECT_UNNAMED_FAILED = "ADD_TO_PROJECT_UNNAMED_FAILED";
export const GET_REQUEST_RESOURCES_BY_FILTERS_INIT =
  "GET_REQUEST_RESOURCES_BY_FILTERS_INIT";
export const GET_REQUEST_RESOURCES_BY_FILTERS_SUCCESS =
  "GET_REQUEST_RESOURCES_BY_FILTERS_SUCCESS";
export const GET_REQUEST_RESOURCES_BY_FILTERS_FAILED =
  "GET_REQUEST_RESOURCES_BY_FILTERS_FAILED";
export const GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_INIT =
  "GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_INIT";
export const GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_SUCCESS =
  "GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_SUCCESS";
export const GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_FAILED =
  "GET_REQUEST_RESOURCES_BY_FILTERS_BY_RM_FAILED";
export const GET_DOWNLOAD_CREATE_PROJECT_INIT =
  "GET_DOWNLOAD_CREATE_PROJECT_INIT";
export const GET_DOWNLOAD_CREATE_PROJECT_SUCCESS =
  "GET_DOWNLOAD_CREATE_PROJECT_SUCCESS";
export const GET_DOWNLOAD_CREATE_PROJECT_FAILED =
  "GET_DOWNLOAD_CREATE_PROJECT_FAILED";
export const CREATE_PROJECT_FROM_EXCEL_INIT = "CREATE_PROJECT_FROM_EXCEL_INIT";
export const CREATE_PROJECT_FROM_EXCEL_SUCCESS =
  "CREATE_PROJECT_FROM_EXCEL_SUCCESS";
export const CREATE_PROJECT_FROM_EXCEL_FAILED =
  "CREATE_PROJECT_FROM_EXCEL_FAILED";
export const CLEAR_PM_LANDING_DATA = "CLEAR_PM_LANDING_DATA";
export const CLEAR_PM_DETAILS_DATA = "CLEAR_PM_DETAILS_DATA";
export const CLEAR_PM_NAMED_DETAILS_DATA = "CLEAR_PM_NAMED_DETAILS_DATA";
export const CLEAR_PM_UNNAMED_DETAILS_DATA = "CLEAR_PM_UNNAMED_DETAILS_DATA";
export const UPDATE_FAVOURITE_STATUS_INIT = "UPDATE_FAVOURITE_STATUS_INIT";
export const UPDATE_FAVOURITE_STATUS_SUCCESS =
  "UPDATE_FAVOURITE_STATUS_SUCCESS";
export const UPDATE_FAVOURITE_STATUS_FAILED = "UPDATE_FAVOURITE_STATUS_FAILED";
export const SHOW_NAMED_UNNAMED_BUTTON_INIT = "SHOW_NAMED_UNNAMED_BUTTON_INIT";
export const SHOW_NAMED_UNNAMED_BUTTON_SUCCESS =
  "SHOW_NAMED_UNNAMED_BUTTON_SUCCESS";
export const SHOW_NAMED_UNNAMED_BUTTON_FAILED =
  "SHOW_NAMED_UNNAMED_BUTTON_FAILED";
export const COMPLIANCE_REPORT_PROJECT_INIT = "COMPLIANCE_REPORT_PROJECT_INIT";
export const COMPLIANCE_REPORT_PROJECT_SUCCESS =
  "COMPLIANCE_REPORT_PROJECT_SUCCESS";
export const COMPLIANCE_REPORT_PROJECT_FAILED =
  "COMPLIANCE_REPORT_PROJECT_FAILED";
export const DOWNLOAD_COMPLIANCE_REPORT_PROJECT_INIT =
  "DOWNLOAD_COMPLIANCE_REPORT_PROJECT_INIT";
export const DOWNLOAD_COMPLIANCE_REPORT_PROJECT_SUCCESS =
  "DOWNLOAD_COMPLIANCE_REPORT_PROJECT_SUCCESS";
export const DOWNLOAD_COMPLIANCE_REPORT_PROJECT_FAILED =
  "DOWNLOAD_COMPLIANCE_REPORT_PROJECT_FAILED";
export const GET_ADMIN_SUPPORT_ACTIVITIES_INIT =
  "GET_ADMIN_SUPPORT_ACTIVITIES_INIT";
export const GET_ADMIN_SUPPORT_ACTIVITIES_SUCCESS =
  "GET_ADMIN_SUPPORT_ACTIVITIES_SUCCESS";
export const GET_ADMIN_SUPPORT_ACTIVITIES_FAILED =
  "GET_ADMIN_SUPPORT_ACTIVITIES_FAILED";
export const UPDATE_ADMIN_SUPPORT_ACTIVITIES_INIT =
  "UPDATE_ADMIN_SUPPORT_ACTIVITIES_INIT";
export const UPDATE_ADMIN_SUPPORT_ACTIVITIES_SUCCESS =
  "UPDATE_ADMIN_SUPPORT_ACTIVITIES_SUCCESS";
export const UPDATE_ADMIN_SUPPORT_ACTIVITIES_FAILED =
  "UPDATE_ADMIN_SUPPORT_ACTIVITIES_FAILED";
export const DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_INIT =
  "DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_INIT";
export const DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_SUCCESS =
  "DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_SUCCESS";
export const DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_FAILED =
  "DOWNLOAD_ADMIN_SUPPORT_ACTIVITIES_FAILED";
export const UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_INIT =
  "UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_INIT";
export const UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_SUCCESS =
  "UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_SUCCESS";
export const UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_FAILED =
  "UPDATE_ADMIN_SUPPORT_RESOURCE_ACTIVITIES_FAILED";
export const ACCEPT_PROJECT_REQUEST_INIT = "ACCEPT_PROJECT_REQUEST_INIT";
export const ACCEPT_PROJECT_REQUEST_SUCCESS = "ACCEPT_PROJECT_REQUEST_SUCCESS";
export const ACCEPT_PROJECT_REQUEST_FAILED = "ACCEPT_PROJECT_REQUEST_FAILED";
export const GET_NAMED_ALLOCATIONS_BY_MAPID_INIT =
  "GET_NAMED_ALLOCATIONS_BY_MAPID_INIT";
export const GET_NAMED_ALLOCATIONS_BY_MAPIDT_SUCCESS =
  "GET_NAMED_ALLOCATIONS_BY_MAPIDT_SUCCESS";
export const GET_NAMED_ALLOCATIONS_BY_MAPID_FAILED =
  "GET_NAMED_ALLOCATIONS_BY_MAPID_FAILED";
export const DOWNLOAD_FILTERED_PROJECT_ANALYTICS_INIT =
  "DOWNLOAD_FILTERED_PROJECT_ANALYTICS_INIT";
export const DOWNLOAD_FILTERED_PROJECT_ANALYTICS_SUCCESS =
  "DOWNLOAD_FILTERED_PROJECT_ANALYTICS_SUCCESS";
export const DOWNLOAD_FILTERED_PROJECT_ANALYTICS_FAILED =
  "DOWNLOAD_FILTERED_PROJECT_ANALYTICS_FAILED";
export const DOWNLOAD_PROJECT_RESOURCE_DATA_INIT =
  "DOWNLOAD_PROJECT_RESOURCE_DATA_INIT";
export const DOWNLOAD_PROJECT_RESOURCE_DATA_SUCCESS =
  "DOWNLOAD_PROJECT_RESOURCE_DATA_SUCCESS";
export const DOWNLOAD_PROJECT_RESOURCE_DATA_FAILED =
  "DOWNLOAD_PROJECT_RESOURCE_DATA_FAILED";
